import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper, zIndex } from '@offerzen/pinata-shame'

export const navbarHeight = 60

const styles = {
  wrapper: css({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: navbarHeight,
    backgroundColor: '#132254',
    zIndex: zIndex.level8,
    display: 'flex',
    alignItems: 'center',

    [mediaQueryHelper(breakpoint.tablet)]: {
      position: 'relative',
    },
  }),

  container: css({
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),

  logo: css({
    display: 'inline-flex',
    alignItems: 'center',

    '&:focus': {
      outline: 'none',
    },
  }),

  logoImage: css({
    height: 28,
  }),

  navItems: css({
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  }),
}

export default styles
